import {PureComponent, Component} from "react"

export interface LoadProps {
  load?: Promise<any> | null
}

type Comp = PureComponent<LoadProps> | Component<LoadProps>

export default class {
  component: Comp
  stateKey: string
  isMounted: boolean

  constructor(component: Comp, stateKey = "loaded") {
    this.component = component
    this.stateKey = stateKey
    this.isMounted = true

    const loaded = this.__load(this.component.props.load)

    this.component.setState({[this.stateKey]: loaded})
  }

  update(nextProps: LoadProps) {
    if (nextProps.load !== this.component.props.load) {
      const loaded = this.__load(nextProps.load)
      this.component.setState({[this.stateKey]: loaded})
    }
  }

  destroy() {
    this.isMounted = false
  }

  __isLoaded(promise: any) {
    const isPromise = promise && "then" in promise
    return isPromise
  }

  __load(load: Promise<any>) {
    let loaded = true
    if (this.__isLoaded(load)) {
      loaded = false
      load
        .catch(() => {
          return true
        })
        .then(() => {
          if (this.isMounted) {
            this.component.setState({[this.stateKey]: true})
          }
        })
    }

    return loaded
  }
}
